import BaseRoute from "../../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../../lib/itn-ui-kit/services/service-container.js";

import Template from "./template";

export default class AnalyticsRouteID extends BaseRoute {
  @service("repositories/dashboard-analytics-repository") dashboardRepository;

  path = ":id";
  element = (<Template />);
  revalidateOnParams = ["id"];

  async loader({ params }) {
    const { id } = params;

    try {
      const analytics = await this.dashboardRepository.findRecord(id, { noCache: true });
      return { analytics };
    } catch (error) {
      console.error("Error loading analytics page:", error);
      return { analytics: null, error };
    }
  }
}
